import type { TemplateCategory } from '@assessos/shared';

import { apiRequest } from './client.js';

export interface AdminTemplateSummary {
  id: string;
  code: string;
  version: number;
  name: string;
  description: string | null;
  /** Sprint A · Historia A2 — categoría devuelta por el endpoint admin. */
  category?: TemplateCategory;
  is_published: boolean;
  published_at: string | null;
}

export interface AdminTemplateDetail extends AdminTemplateSummary {
  created_at: string;
  schema: unknown;
}

export const adminSurveysApi = {
  list: (opts: { category?: TemplateCategory } = {}) => {
    const qs = opts.category ? `?category=${encodeURIComponent(opts.category)}` : '';
    return apiRequest<{ templates: AdminTemplateSummary[] }>(`/api/v1/admin/surveys${qs}`);
  },
  get: (id: string) => apiRequest<AdminTemplateDetail>(`/api/v1/admin/surveys/${id}`),
  create: (input: { code: string; name: string; description?: string; schema: unknown }) =>
    apiRequest<AdminTemplateSummary>('/api/v1/admin/surveys', { method: 'POST', body: input }),
  update: (id: string, input: { name?: string; description?: string; schema?: unknown }) =>
    apiRequest<AdminTemplateSummary>(`/api/v1/admin/surveys/${id}`, {
      method: 'PATCH',
      body: input,
    }),
  publish: (id: string) =>
    apiRequest<AdminTemplateSummary>(`/api/v1/admin/surveys/${id}/publish`, { method: 'POST' }),
};
